import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static targets = ["list", "template"]
  add() {
    const positions = [...this.listTarget.querySelectorAll('input[name$="[position]"]')].map(input => Number(input.value) || 0)
    const holder = document.createElement("div")
    holder.innerHTML = this.templateTarget.innerHTML.replaceAll("NEW_RECORD", `new_${Date.now()}_${Math.random().toString(36).slice(2)}`)
    holder.querySelector("[data-position]").value = Math.max(0, ...positions) + 1
    this.listTarget.append(...holder.children)
  }
  remove(event) { (event.currentTarget.closest("[data-repertoire-item]") || event.currentTarget.parentElement).remove() }
}
